// ————————————————————————————————————————————— DOC. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const consoleStyles = {
  default: "color: orange; font-weight: bold;",
  success: "color: green; font-weight: bold;",
  error: "color: red; font-weight: bold;",
};

// ——————————————————————————————————————— API METHOD DEF. ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function toggle_nav(el_wrpr, config = { setFirstLinkActive: false }) {
  ////////////// Setup ///////////////
  ////////////////////////////////////

  const { setFirstLinkActive = false } = config || {};
  const { wrpr_btnGroups, nav_intro, nav_bewerben, nav_allgemein } = this.ref;
  console.log("%c[SectionScroller] toggle_nav() called", consoleStyles.default);

  ////////////// ACTION //////////////
  ////////////////////////////////////

  const id_wrpr = el_wrpr.getAttribute("data-id");
  const ch_wrpr = el_wrpr.getAttribute("data-chapter");
  const subch_wrpr = el_wrpr.getAttribute("data-subchapter");

  // console.log("Chapter:", ch_wrpr, "ID:", id_wrpr, "Wrapper:", el_wrpr);

  // When entering intro/hero section, hide all nav. btn. groups
  if (ch_wrpr === "intro" && id_wrpr === "hero") {
    wrpr_btnGroups.style.setProperty("--w", "0px");
    [nav_intro, nav_bewerben, nav_allgemein].forEach((n) => (n.dataset.active = "false"));
  }
  // When entering any other section, reveal corresp. nav. btn. group
  else {
    // Check if any nav. is active
    // (to determ. if active-bg. updt. needs to wait for hide trans. to complete)
    // const has_activeNav = [nav_intro, nav_bewerben, nav_allgemein].some((n) => n.dataset.active === "true");
    const has_activeNav = true;

    // Reveal corresp. nav. btn. group and hide others
    [nav_intro, nav_bewerben, nav_allgemein].forEach((n) => {
      // const is_active_ch = n.dataset.chapter === ch_wrpr;
      const is_active_subch = n.dataset.chapter === subch_wrpr;
      const is_active = is_active_subch;
      if (is_active) {
        // - Measure width of active nav and set btnGroups wrpr width to it
        // - Reveal active nav
        // - Updt. active-link bg. position/width
        wrpr_btnGroups.style.setProperty("--w", `${n.getBoundingClientRect().width}px`);
        n.dataset.active = "true";
        if (setFirstLinkActive) setTimeout(() => this.api.toggle_activeNavLink(n), has_activeNav ? 300 : 0); // wait for hide trans. to complete
      } else {
        n.dataset.active = "false";
      }
    });
  }

  ///////////// Conclude /////////////
  ////////////////////////////////////

  console.log("%c[SectionScroller] toggle_nav() complete", consoleStyles.success);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
